export default __webpack_public_path__ + "static/brokers-image-5-de6f7f257b29d2eb83b2e4a8ee17e926.png";